export enum FeatureFlagName {
  SUITABLE_SUBSTITUTES = 'suitable_substitutes',
  PART_FINDER_REPORTS = 'part_finder_reports',
  NEW_COMPARE_ASSETS_UI = 'new_compare_assets_ui',
  SUPPLEMENTAL_ASSETS = 'supplemental_assets',
  CRITICAL_GEOMETRY = 'critical_geometry',
  METADATA_SEARCH_UI = 'metadata_search_ui',
  USAGE_ANALYTICS = 'usage_analytics',
  IMAGE_SEARCH_CROPPING_DISABLED = 'image_search_cropping_disabled',
  SEMANTIC_DESCRIPTION_GENERATION = 'semantic_description_generation',
  SEMANTIC_DESCRIPTION_VISIBILITY = 'semantic_description_visibility',
  COMPARISON_HEATMAP = 'comparison_heatmap',
  TAXONOMY = 'taxonomy',
  TAXONOMY_AI_CLASSIFICATION = 'taxonomy_ai_classification',
}

/**
 * @deprecated Use useFeatureFlags for API-controlled feature flags
 */
export const isFeatureEnabled = (flagName: string): boolean => {
  const environmentVariableName = `VITE_${flagName}`;
  return import.meta.env[environmentVariableName] === 'true';
};

/**
 * @deprecated Use useFeatureFlags for API-controlled feature flags
 */
export const FEATURE_FLAGS = {
  ADVANCED_ANALYSIS: 'FLAG_ADVANCED_ANALYSIS_ENABLED',
} as const;
